import emitter from "@/js/utils/emitter.js";

export default {
  install: (app) => {
    app.config.globalProperties.$emitter = emitter;
  },
};
